export default __webpack_public_path__ + "static/inbox-page-1d279e82746534e9c7bb9ba72a8bb959.png";